import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Headers, Http } from "@angular/http";

@Injectable()
export class StoreSaleService {
  headers: Headers;
  url = environment.api_evs;
  url2 = environment.api_evs + "/qr-core-aps";

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    const lang = localStorage.getItem('lang') || 'vi';
    this.headers = new Headers({
      "Content-Type": "application/json",
      Authorization: `${token}`,
      "Accept-Language": lang
    });
  }

  getList(query?: any): Observable<any> {
    return this.http
      .get(`${this.url2}/point_of_sales`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  detailStoreSale(storeId?: any): Observable<any> {
    return this.http.get(`${this.url2}/point_of_sales/${storeId}`, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  addNewStoreSale(body?: any): Observable<any> {
    return this.http.post(`${this.url2}/point_of_sales`, body, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  updateStoreSale(storeId, body?: any): Observable<any> {
    return this.http.put(`${this.url2}/point_of_sales/${storeId}`, body, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  deleteSoreSale(storeId): Observable<any> {
    return this.http.delete(`${this.url2}/point_of_sales/${storeId}`, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      ._catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  uploadFileProduct(file?: any): Observable<any> {
    this.headers.delete("Content-Type");
    if (localStorage.getItem("Access-Token")) {
      this.headers.set("authorization", localStorage.getItem("Access-Token"));
    }
    let formData = new FormData();
    formData.append("file", file, file.name);
    return this.http
      .post(`${this.url2}/point_of_sales/import`, formData, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // uploadFileProduct(file: File, responseType?: string, postData?: any) {
  //   if (responseType == '' || responseType == undefined || responseType == null) {
  //     responseType = 'json';
  //   }
  //   let url = environment.api_evs + '/qr-core-aps' + '/products/import';
  //   return this.postWithFile(url, file, postData);
  // }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store-sale/services/store-sale.service.ts